import React, { useState } from 'react';
import VIPFeatures from './VIPFeatures';
import './VIPPricing.css';
import ReactDOM from 'react-dom';

const VIPPricing = ({ onClose, onShowFeatures }) => {
  const [copied, setCopied] = useState(false);
  const [showFeatures, setShowFeatures] = useState(false);
  const bankInfo = {
    accountNumber: '9131545431',
    bank: 'Vietcombank',
    accountName: 'Lê Thế Bình'
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(bankInfo.accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleHelpClick = () => {
    window.open('https://www.facebook.com/lethebinh13', '_blank');
  };

  const handleShowFeatures = () => {
    setShowFeatures(true);
  };

  const handleCloseFeatures = () => {
    setShowFeatures(false);
  };

  return (
    <div className="vip-pricing-overlay">
      <div className="vip-pricing-modal">
        <button className="close-button" onClick={onClose}>✕</button>
        
        <h2 className="pricing-title">Gia hạn VIP 👑</h2>
        
        <div className="pricing-content">
          <div className="price-display">
            <h3 className="section-title">Thông báo đặc biệt</h3>
            <div className="price-options">
              <div className="price-option">
                <div className="price-container">
                  <div className="price-info">
                    <div className="current-price-row">
                      <span className="diamond-icon">🎁</span>
                      <span className="current-price free-price">50 lượt</span>
                      <span className="promotion-badge">Miễn phí</span>
                    </div>
                    <span className="promo-note">Sử dụng trong 30 ngày</span>
                    <span className="promo-note-sub">Nhận ngay khi hoàn thành các bước</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="payment-section">
            <h3 className="section-title">Hướng dẫn kích hoạt</h3>
            <div className="activation-steps">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <span>Like & Chia sẻ công khai </span>
                  <a href="https://www.facebook.com/lethebinh13" target="_blank" rel="noopener noreferrer">
                    Bài viết của mình
                  </a>
                  <span> lên trang cá nhân</span>
                </div>
              </div>
              
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  Nhắn link bài chia sẻ qua{' '}
                  <a href="https://www.facebook.com/lethebinh13" target="_blank" rel="noopener noreferrer">
                    Facebook của mình
                  </a>
                </div>
              </div>

              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  Nhận tài khoản VIP
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="action-buttons" style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
          <button 
            className="show-features-button" 
            onClick={handleShowFeatures}
            style={{ 
              backgroundColor: '#FFE100',
              color: '#000',
              fontWeight: 'bold',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '14px',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}
          >
            Xem tính năng VIP 👑
          </button>
          <button 
            className="action-button help" 
            onClick={handleHelpClick}
            style={{
              backgroundColor: '#8B5CF6',
              color: '#fff',
              padding: '8px 16px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '14px',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            Trợ giúp?
          </button>
        </div>
      </div>
      {showFeatures && (
        <VIPFeatures 
          onClose={handleCloseFeatures}
          onShowPricing={() => setShowFeatures(false)}
        />
      )}
    </div>
  );
};

export default VIPPricing;